export const calculateBundleSubItemQuantity = (
  bundleQuantity: number | null,
  itemQuantity: number | null
) => {
  if (bundleQuantity && itemQuantity) return bundleQuantity * itemQuantity;
  return 0;
};
